export enum CostType {
  CONSTRUCTION = 'CONSTRUCTION',
  ALL = 'ALL'
}
